export let formulaManager = {
  init: function () {},

  setFormulaText: function (output, latex, callback) {
    output.innerHTML = '';

    MathJax.texReset();
    var options = MathJax.getMetricsFor(output);
    MathJax.tex2chtmlPromise(latex, options)
      .then(function (node) {
        if (node.querySelector('mjx-merror')) {
          throw new Error('mjx error');
        }
        output.appendChild(node);
        MathJax.startup.document.clear();
        MathJax.startup.document.updateDocument();

        if (callback) {
          callback(true);
        }
      })
      .catch(function (err) {
        if (err) {
          if (callback) {
            callback(false);
          }
        }
      });
  },
};
